import useSWR from 'swr';
import { useSelector } from 'react-redux';

import * as http from 'utils/http';
import config from 'config';
import { adaptFiltersForBackend } from 'modules/tasks/filters/filter-computations';
import { useTasksFiltersContext } from 'modules/tasks/filters/context';
import serialize from 'utils/serialize';

function fetcher(url) {
  return http.get(`${config.API_URL}${url}`);
}

export const useFilterCounters = (filter) => {
  const me = useSelector((state) => state.me);
  const { filters } = useTasksFiltersContext();
  const { [filter]: _, ...restOfFilters } = adaptFiltersForBackend(filters);

  const filtersQuery = serialize(restOfFilters);

  const { data: counters } = useSWR(
    !!me?.id && `mercury/journey_summaries/counters/?${filtersQuery}`,
    fetcher,
    {
      refreshInterval: 40000,
    }
  );

  return counters;
};
